import { render, staticRenderFns } from "./aggiungiVariazioni.vue?vue&type=template&id=2660e2f1"
import script from "./aggiungiVariazioni.vue?vue&type=script&lang=js"
export * from "./aggiungiVariazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports